import { render, staticRenderFns } from "./PosSolde.vue?vue&type=template&id=8288f004&"
import script from "./PosSolde.vue?vue&type=script&lang=js&"
export * from "./PosSolde.vue?vue&type=script&lang=js&"
import style0 from "./PosSolde.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports